/**
 * Besuchszähler – wird beim App-Start einmal pro Laden hochgezählt.
 *
 * Der Wert steuert Einblendungen in anderen Komponenten (Startadress-Hinweis,
 * Installations-Hinweis); hier wird er nur geführt, nicht ausgewertet.
 */
export const VISIT_COUNT_KEY = 'visit_count';

// React.StrictMode ruft Effekte im Dev-Modus doppelt auf; ohne diesen
// Modul-Flag würde jeder Ladevorgang lokal zwei Besuche zählen.
let countedThisLoad = false;

/** Zählt den aktuellen Besuch und gibt den neuen Stand zurück. */
export const registerVisit = () => {
  if (countedThisLoad) return getVisitCount();
  countedThisLoad = true;

  const next = getVisitCount() + 1;
  try {
    localStorage.setItem(VISIT_COUNT_KEY, String(next));
  } catch {
    // Privater Modus / gesperrter Speicher: Zähler bleibt einfach bei 0.
  }
  return next;
};

/**
 * Nummer des laufenden Besuchs.
 *
 * Zählt bei Bedarf selbst hoch: Kind-Komponenten rendern, bevor der Effekt in
 * App.jsx läuft, und würden sonst noch den Stand des vorherigen Besuchs sehen.
 */
export const getCurrentVisit = () => registerVisit();

/** Gespeicherter Stand; 0, wenn noch nie gezählt wurde. */
export const getVisitCount = () => {
  try {
    const stored = parseInt(localStorage.getItem(VISIT_COUNT_KEY), 10);
    return Number.isNaN(stored) ? 0 : stored;
  } catch {
    return 0;
  }
};
